import axios from "axios";

// const headers = {
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// };

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

function getHeaders2() {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const login = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/login/`,
    data,
    getHeaders()
  );
  return response;
};

export const forgetPassword = async (emailData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/forget-password/`,
      emailData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const register = async (data) => {
  // headers);
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/register/`,
    data,
    getHeaders()
  );
  return response;
};
export const getUser = async () => {
  // headers);
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/register/`,

    getHeaders()
  );
  return response;
};

export const handlePayDeposit = async () => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/student/deposit/`,
    {},
    getHeaders()
  );
  return response;
};

export const uploadDocuments = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/student/student_doc_upload/`,
    data,
    getHeaders2()
  );
  return response;
};

export const submitApplication = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/student/create-application/`,
    data,
    getHeaders()
  );
  return response;
};

export const updateApplication = async (data) => {
  const response = await axios.put(
    `${process.env.REACT_APP_BASE_URL}/student/create-application/`,
    data,
    getHeaders()
  );
  return response;
};
// export const getApplication = async () => {
//   const response = await axios.get(
//     `${process.env.REACT_APP_BASE_URL}/invoice_price/test-preparation-services/`,
//     getHeaders()
//   );
//
//     "Data being sent to API of getTestPreparationServices:",
//     response.data
//   );
//   return response.data;
// };
// Get List of Test Preparation Services
export const getTestPreparationServices = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/test-preparation-services/`,
    getHeaders()
  );

  return response.data;
};
// Create a New Test Preparation Service
export const createTestPreparationService = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/test-preparation-services/`,
    data,
    getHeaders()
  );

  return response.data;
};

// Update a Test Preparation Service
export const updateTestPreparationService = async (id, data) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/test-preparation-services/${id}/`,
    data,
    getHeaders()
  );

  return response.data;
};

// Delete a Test Preparation Service
export const deleteTestPreparationService = async (id) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/test-preparation-services/${id}/`,
    getHeaders()
  );

  return response.data;
};

// =======================================================

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/notifications/notifications/mark-as-read/${notificationId}/`,
      {},
      getHeaders()
    );

    return response.data; // Returns success message
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};
export const markAllNotificationsAsRead = async (id) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/notifications/notifications/mark-all-as-read/${id}/`,
      {},
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error marking notifications as read:", error);
    throw new Error(
      "Unable to mark notifications as read. Please try again later."
    );
  }
};

// Get List of Abroad Counseling Services
export const getAbroadCounselingServices = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/abroad-counseling-services/`,
    getHeaders()
  );

  return response.data;
};
export const editRoleAssigner = async (id, data) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/user/admin-profile/${id}/`,
    data,
    getHeaders()
  );
  return response.data;
};

// export const deleteRoleAssigner = async (id) => {
//   const response = await axios.delete(
//     `${process.env.REACT_APP_BASE_URL}/user/admin-profile/${id}/`,
//     getHeaders()
//   );
//   "deleteRoleAssigner", response.data); // Debugging line
//   return response.data;
// };

export const deleteRoleAssigner = async (id) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/user/register/${id}/`,
    getHeaders()
  );
  return response.data;
};

// Create a New Abroad Counseling Service
export const createAbroadCounselingService = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/abroad-counseling-services/`,
    data,
    getHeaders()
  );
  return response.data;
};

// Update an Abroad Counseling Service
export const updateAbroadCounselingService = async (id, data) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/abroad-counseling-services/${id}/`,
    data,
    getHeaders()
  );

  return response.data;
};

export const getstudentNotification = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notifications/notifications/student/${id}/`
    );
    return response;
  } catch (err) {
    console.error(err);
  }
};

// Delete an Abroad Counseling Service
export const deleteAbroadCounselingService = async (id) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/abroad-counseling-services/${id}/`,
    getHeaders()
  );

  return response.data;
};

// =======================================================

// Get List of Career Counseling Services
export const getCareerCounselingServices = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/career-counseling-services/`,
    getHeaders()
  );

  return response.data;
};

// Create a New Career Counseling Service
export const createCareerCounselingService = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/career-counseling-services/`,
    data,
    getHeaders()
  );

  return response.data;
};

// Update a Career Counseling Service
export const updateCareerCounselingService = async (id, data) => {
  const response = await axios.put(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/career-counseling-services/${id}/`,
    data,
    getHeaders()
  );
  return response.data;
};

// Delete a Career Counseling Service
export const deleteCareerCounselingService = async (id) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/career-counseling-services/${id}/`,
    getHeaders()
  );

  return response.data;
};

// =======================================================

// Get List of Other Services
export const getOtherServices = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/other-services/`,
    getHeaders()
  );
  return response.data;
};
export const getProfileBuildingServices = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/profile-building-services/`,
    getHeaders()
  );

  return response.data;
};

// Create a New Other Service
export const createOtherService = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/other-services/`,
    data,
    getHeaders()
  );
  return response.data;
};
export const createProfileBuildingService = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/profile-building-services/`,
    data,
    getHeaders()
  );

  return response.data;
};

// Update an Other Service
export const updateOtherService = async (id, data) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/other-services/${id}/`,
    data,
    getHeaders()
  );
  return response.data;
};
export const updateProfileBuildingService = async (id, data) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/profile-building-services/${id}/`,
    data,
    getHeaders()
  );

  return response.data;
};

// Delete an Other Service
export const deleteOtherService = async (id) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/other-services/${id}/`,
    getHeaders()
  );
  return response.data;
};
export const deleteProfileBulldingService = async (id) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/invoice_price/api/profile-building-services/${id}/`,
    getHeaders()
  );

  return response.data;
};

export const getVisaDetails = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/student/visa-process-details/${id}/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    console.error(
      "Error in getApplicationById:",
      error.response || error.message
    );
    throw error;
  }
};

export const getApplication = async (id) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/get-application/${id}/`,
    getHeaders()
  );

  return response.data; // Ensure you're returning the data part
};

export const getChatNotifications = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/chat_app/notifications/`,
      getHeaders()
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const MarkSideBarChatNotifications = async (payload) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_BASE_URL}/chat_app/notifications/mark-read/`,
      payload,
      getHeaders()
    );
  } catch (error) {
    console.error("Mark read error:", error?.response?.data || error);
    throw error;
  }
};

export const applyLoan = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/student/apply-loan/`,
    data,
    getHeaders()
  );

  return response.data;
};
export const changeUserPassword = async (data) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/change/password/`,
    data,
    getHeaders()
  );
  return response.data;
};

export const fetchSampleDocumentDetails = async (selectedType) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/resources/api/sample-documents/level/${selectedType}/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const fetchDocumentOption = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/resources/api/sample-documents/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
